import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import Tag from 'ext:flarum/tags/common/models/Tag';
import Block from './models/Block';
import Status from './models/Status';
import Donation from './models/Donation';
import StatusGambit from './query/discussions/StatusGambit';
export default [new Extend.Store().add('nh-blocks', Block).add('nh-statuses', Status).add('nh-donations', Donation), new Extend.Model(Tag).attribute('nhPostCount').attribute('nhDiscussionCount').attribute('nhBlockId').hasOne('nhBlock'), new Extend.Model(Discussion).hasOne('nhStatus').attribute('canNhStatus'), new Extend.Search().gambit('discussions', StatusGambit)];